import { configureStore } from "@reduxjs/toolkit";

import locationsReducer from "./locations";
import permissionsReducer from "./permissions";
import positionsReducer from "./positions";
import usersReducer from "./users";
import userReducer from "./user";
import impersonationReducer from "./impersonation";
import glAccountsReducer from "./glAccounts";
import groupsReducer from "./groups";
import assetsReducer from "./assets";
import vendorsReducer from "./vendors";
import catalogSessionReducer from "./catalogSession";

export default configureStore({
  reducer: {
    permissions: permissionsReducer,
    positions: positionsReducer,
    locations: locationsReducer,
    users: usersReducer,
    user: userReducer,
    impersonation: impersonationReducer,
    glAccounts: glAccountsReducer,
    groups: groupsReducer,
    assets: assetsReducer,
    vendors: vendorsReducer,
    catalogSession: catalogSessionReducer,
  },
});
